import { KeyRoles, RoleStatus } from "../../types/enums";
import { Stack } from "@mui/material";
import { keyRolesItems } from "../../types/genereal";

export const KeyRoleMapper = ({
  item,
  roleStatus = RoleStatus.active,
}: {
  item: KeyRoles;
  roleStatus?: RoleStatus;
}) => {
  if (!item) return null;

  return (
    <Stack alignItems="flex-start">
      <span
        style={{
          borderRadius: "8px",
          padding: "4px 8px",
          fontSize: "14px",
          fontWeight: 550,
          color:
            roleStatus && roleStatus === RoleStatus.active
              ? keyRolesItems[item].color
              : "#585858",
          backgroundColor:
            roleStatus && roleStatus === RoleStatus.active
              ? keyRolesItems[item].backgroundColor
              : "#5858580D",
          textAlign: "left",
          userSelect: "none",
        }}
      >
        {keyRolesItems[item].title}
      </span>
    </Stack>
  );
};
